export enum ActiveEnum {
	ACTIVE = 'true',
	INACTIVE = 'false',
}

export const ActivationStatus: { name: string; value: any }[] = [
	{ name: 'ACTIVE', value: true },
	{ name: 'INACTIVE', value: false },
]
export const BusinessStatus: { name: string; value: any }[] = [
	{ name: 'BEAUTY_SALON', value: true },
	{ name: 'ONLINE_STORE', value: false },
]

export enum Agent {
	GoCare,
	Client,
	ServiceProvider,
}

export const AgentArray: { name: string; value: any }[] = [
	{ name: 'GO_CARE', value: 0 },
	{ name: 'CLIENT', value: 1 },
	{ name: 'SERVICE_PROVIDER', value: 2 },
]
